
import API from '@/api'

const actions = {
  getExcursions(context, { excursionIndex, form }) {
    const {
      commit,
      getters,
      state,
      dispatch
    } = context

    API.excursions.getCollection(form)
      .then(({ data: { data } }) => {
        if (state.excursions[excursionIndex].excursions.hasError) {
          commit('setServiceModuleErrors', {
            target: `excursions.${excursionIndex}.excursions`,
            status: false,
            errors: []
          })
        }

        commit('updateServiceModuleIsLoading', {
          status: false,
          target: `excursions.${excursionIndex}.excursions`
        })

        commit('setExcursions', {
          excursionIndex,
          ...data
        })

        const selected = state.excursions[excursionIndex].selected
        const index = selected.length - 1

        dispatch('getServicePenaltiesForAll', {
          ids: {
            ...getters.getExcursionPenaltiesData({
              excursionIndex,
              index
            }),
            currency: getters.getCartPrice.currency
          },
          serviceName: 'excursions',
          serviceId: `${data.searchId}_${excursionIndex}_${index}`,
          apiModuleName: 'excursions',
          label: `Экскурсия: ${selected[index].current.name}`
        })

        if (data.results.length === 0) {
          commit('setServiceModuleErrors', {
            target: `excursions.${excursionIndex}.excursions`,
            status: true,
            errors: ['По вашему запросу ничего не найдено, измените параметры поиска.']
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('updateServiceModuleIsLoading', {
          status: false,
          target: `excursions.${excursionIndex}.excursions`
        })
        commit('setServiceModuleErrors', {
          target: `excursions.${excursionIndex}.excursions`,
          status: true,
          errors
        })
      })
  },
  getExcursionDetails({ commit }, { excursionIndex, form }) {
    API.excursions.getExcursionDetails(form)
      .then(({ data }) => {
        commit('setExcursionDetails', {
          excursionIndex,
          details: data
        })
        commit('setExcursionDetailsLoading', {
          excursionIndex,
          status: false
        })
      })
      .catch(() => {
        commit('setServiceModuleErrors', {
          target: `excursions.${excursionIndex}.details`,
          status: true,
          errors: ['Ошибка детализации экскурсии']
        })
        commit('setExcursionDetailsLoading', {
          excursionIndex,
          status: false
        })
      })
  }
}

export default actions